var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    {
      attrs: {
        appBarTitle: _vm.$tr("editChannelOrderTitle"),
        route: _vm.backRoute,
      },
    },
    [
      _c(
        "KPageContainer",
        { staticClass: "device-container" },
        [
          _c("p", { staticClass: "instructions" }, [
            _vm._v("\n      " + _vm._s(_vm.$tr("instructions")) + "\n    "),
          ]),
          !_vm.loading && _vm.channels.length === 0
            ? _c("p", [
                _vm._v("\n      " + _vm._s(_vm.$tr("noChannels")) + "\n    "),
              ])
            : [
                _c(
                  "DragContainer",
                  {
                    staticClass: "container",
                    attrs: { items: _vm.channels },
                    on: { sort: _vm.handleOrderChange },
                  },
                  [
                    _c(
                      "transition-group",
                      {
                        staticClass: "wrapper",
                        attrs: { tag: "div", name: "list" },
                      },
                      _vm._l(_vm.channels, function (channel, index) {
                        return _c(
                          "Draggable",
                          { key: channel.id },
                          [
                            _c("DragHandle", [
                              _c(
                                "div",
                                {
                                  staticClass: "item",
                                  class: _vm.$computedClass(_vm.itemClass),
                                  style: {
                                    backgroundColor: _vm.$themeTokens.surface,
                                  },
                                },
                                [
                                  _c("DragSortWidget", {
                                    staticClass: "sort-widget",
                                    attrs: {
                                      moveUpText: _vm.$tr("upLabel", {
                                        name: channel.name,
                                      }),
                                      moveDownText: _vm.$tr("downLabel", {
                                        name: channel.name,
                                      }),
                                      isFirst: index === 0,
                                      isLast: index === _vm.channels.length - 1,
                                    },
                                    on: {
                                      moveUp: function ($event) {
                                        return _vm.shiftOne(index, -1)
                                      },
                                      moveDown: function ($event) {
                                        return _vm.shiftOne(index, +1)
                                      },
                                    },
                                  }),
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(channel.name) +
                                        "\n                "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }